<template>
  <button
    @click="showDialpad"
    title="Open dialpad"
    v-tippy>
    <DialpadIcon />
  </button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import DialpadIcon from '@/components/shared/DialpadIcon'

const { mapActions } = createNamespacedHelpers('conference')

export default {
  components: {
    DialpadIcon
  },
  methods: mapActions([
    'showDialpad'
  ])
}
</script>



// WEBPACK FOOTER //
// dialpad-button.vue?2468bb82